import { useDeleteTourMutation } from '@carboncopyco/data';
import { DeleteOutlineIcon } from '@carboncopyco/icons';
import type { Folder, IOrganizationData, Tour } from '@carboncopyco/types';
import { ConfirmAlert, notify } from '@carboncopyco/ui';
import { useTourAnalytics } from '@carboncopyco/utils';
import { useBoolean } from 'ahooks';

type ArchiveTourModalProps = {
  onClose: () => void;
  show: boolean;
  tourId: Tour['id'];
  organizationId: IOrganizationData['id'];
  navigateOnSuccess?: () => void;
  folderId?: Folder['id'];
};

export const ArchiveTourModal = ({
  onClose,
  show,
  tourId,
  organizationId,
  navigateOnSuccess,
  folderId,
}: ArchiveTourModalProps) => {
  const { trackTourClickArchiveApprove, trackTourClickArchiveCancel } =
    useTourAnalytics({
      location: 'tour_info_page_archive_modal',
      tourId,
    });
  const [archiveTour, { isLoading }] = useDeleteTourMutation();
  const [isDisabled, setIsDisabled] = useBoolean();

  return (
    <ConfirmAlert
      disabled={isDisabled}
      loading={isLoading}
      title="Archive tour"
      description="This tour will no longer be accessible unless it’s restored."
      show={show}
      onConfirm={() => {
        setIsDisabled.setTrue();
        trackTourClickArchiveApprove();
        archiveTour({
          id: tourId,
          organizationId: String(organizationId),
          folderId,
        })
          .unwrap()
          .then(() => {
            navigateOnSuccess?.();
            notify.success('Archived tour successfully');
          })
          .catch((error) => {
            const errorMessage = error?.data?.message;
            if (errorMessage.includes('Playbook')) {
              notify.error(error.data.message);
              return;
            }
            notify.error('Error archiving clone');
          })
          .finally(() => {
            setIsDisabled.setTrue();
            onClose();
          });
      }}
      onClose={() => {
        trackTourClickArchiveCancel();
        onClose();
      }}
      danger
      containerClass="w-ds-normal-modal"
      yesIcon={<DeleteOutlineIcon />}
      yesLabel="Archive"
    />
  );
};
